export default {
  commodities: [],

  companies: [],

  branches: [],

  myBranches: [],

  myFiscalYear: [],

  roles: [],

  units: [],

  materials: [],

  products: [],

  customers: [],

  categories: [],

  branchYears: [],

  users: [],

  wares: [],

  settlementTypes: [],

  wareShelfInfos: [],
  wareShelfInfos2: [],

  waresWithoutLimit: [],

  wareCategories: [],

  countries: [],

  allProvinces: [],

  provinces: [],

  provincesForAddress: [],

  allCities: [],

  cities: [],

  citiesForAddress: [],

  regions: [],

  persons: [],

  personTypes: [],

  prefixes: [],

  personGroups: [],

  personClubs: [],

  personBranches: [],

  positionInformation: [],

  maritalStatuses: [],

  sbus: [],

  sbuTypes: [],

  boms: [],

  orders: [],

  produceOrderProcesses: [],

  userGroups: [],

  branchFiscalYears: [],

  fiscalYearById: [],

  permissions: [],

  companySubSystems: [],
  companySubSystemsLoaded: false,

  floatAccounts: [],

  floatAccountTypes: [],

  floatAccountGroups: [],

  floatAccountGroups1: [],

  floatAccountGroups2: [],

  floatAccountGroups3: [],

  floatAccountGroups4: [],

  floatAccountGroups5: [],

  gender: [],

  commodityGroups: [],

  invoiceTypes: [],

  personGrades: [],

  wareVoucherTypes: [],

  accountInfos: [],

  dataOperations: [],

  dataUsers: [],

  additionalCommodityParamenterTypes: [],

  filedTypes: [],

  receiptWareVoucherTypes: [],

  tempReceiptWareVoucherTypes: [],

  floatAccountConfigs: [],

  floatAccounts1: [],

  floatAccounts2: [],

  floatAccounts3: [],

  floatAccounts4: [],

  floatAccounts5: [],

  floatAccountText: [],

  reviewVoucherAmountFilterTypes: [],

  additionalCommodityParameters: [],

  accountTypes: [],

  accountControls: [],

  accountActions: [],

  draftWareVoucherType: [],

  suppliers: [],

  cashiers: [],

  buyers: [],

  receivers: [],

  sbuTree: [],

  wareCommodities: [],

  destinationWareCommodities: [],

  positionInfoTree: [],

  cartable: [],

  drafts: [],

  commodityUnitCounts: [],

  commodityParameters: {},

  commodityBatches: [],

  itemGroupTree: [],

  buyRequests: [],

  vehicleTypes: [],

  warehousingTypes: [],

  tempReceipts: [],

  personClubGroups: [],

  deliveryMethods: [],

  paymentMethods: [],

  occasionTypes: [],

  campaignTypes: [],

  salesChannels: [],

  introducedTypes: [],

  tags: [],

  processTypes: [],

  feedBackTypes: [],

  processServiceTypes: [],

  feedBacks: [],

  workStations: [],

  grades: [],

  feedbackQuestionOptions: [],

  financialRatios: [],

  answerTypes: [],

  currencyTypes: [],

  smsTemplates: [],

  saleSettings: [],

  turnTypes: [],

  chequeStatusTypes: [],

  banks: [],

  bankBranchs: [],

  chequeTemplates: [],

  bankCashAccount: [],

  requestType: [],

  voucherNoteTypes: [],

  defaultVoucherDescriptions: [],

  chequeStatuses: [],

  voucherTemplateType: [],

  voucherTemplateKeyType: [],

  smsTypes: [],

  transactionInfo: [],

  parakCommodityGroup: [],

  parakCommodities: [],

  requestPayment: [],

  chequeBatches: [],

  dateTypes: [],

  settingDropdownCache: {},

  packageTypes: [],

  MRPProcessTypes: [],

  subMRPProcessTypes: [],

  excelSampleType: [],

  excelSampleDetailType: [],

  excelSampleDetailInformationType: [],

  excelSampleDetailTurnIntoType: [],

  receiveChequeFilters: [],

  paymentChequeFilters: [],

  receipts: [],

  sprints: [],

  produceOrders: [],

  coilCertificates: [],

  monthlyComparisonReceiveChequeFilters: [],

  monthlyComparisonPaymentChequeFilters: [],

  summaryPaymentChequeFilters: [],

  summaryReceiveChequeFilters: [],

  casterProduceOrders: [],

  productionReports: [],

  workStationStatuses: [],

  inputTypes: [],

  productionGroups: [],

  purchaseContracts: [],

  saleTypes: [],

  orderCommodities: [],

  orderCommodityStatus: [],

  orderBoms: [],

  productionGroupSuppliers: [],

  agents: [],

  salesManagers: [],

  purchaseManagers: [],

  distributors: [],

  drivers: [],

  sellers: [],

  employers: [],

  employees: [],

  contractors: [],

  bomSetting: [],

  parakPersonDealTypes: [],

  parakCottage: [],

  parakSettlementType: [],

  parakOrderOperations: [],

  parakPurchases: [],

  parakOrders: [],

  parakVoucherType: [],

  parakLadingOperation: [],

  personAddress: [],

  commodityAdditionalInfos: [],

  addMinusType: [],

  saleExcelSampleType: [],

  saleExcelSampleDetailType: [],

  cancelStatuses: [],

  buyFactorTypes: [],

  returnedFactorTypes: [],

  saleSaleTypes: [],

  salePricePolicesTypes: [],

  saleFactorType: [],

  saleCancelStatus: [],

  saleVoucherStatus: [],

  salePricePolices: [],

  saleAddMinuses: [],

  receiveAndPay: [],

  accountConfigs: [],

  searchTypes: [],

  documentTypes: [],

  saleAgents: [],

  factorFormats: [],

  saleSaleManager: [],

  saleCommissionTypes: [],

  scmsBuyTypes: [],

  buyAddMinuses: [],

  listSetting: [],

  saleFactors: [],

  vouchers: [],
  reportVouchers: [],

  returnBuyFactors: [],

  transferCommodites: [],

  warehousings: [],

  productions: [],

  receiptCartableConfirm: [],

  draftCartableConfirm: [],

  saleCartableConfirm: [],

  salesReturnCartableConfirm: [],

  buyFactorCartableConfirm: [],

  buyReturnCartableConfirm: [],

  reqBuyCartableConfirm: [],

  reqPaymentCartableConfirm: [],

  chequePaymentCartableConfirm: [],

  receiveChequeCartableConfirm: [],

  currentPersonInVoucherDetails: [],

  buyFactors: [],

  returnSaleFactors: [],

  transactionTypes: [],

  personOfficeReportTypes: [],

  inspectionLevels: [],

  dateTimeFormats: [],

  monthlyAccountingVoucherKeyTypes: [],

  managementCartable: [],

  hardnesses: [],

  productSurfaces: [],

  usageGroups: [],

  foilUsages: [],

  innerCoreDiameters: [],

  report: [],

  reportDropDown: [],

  exportFileFormatTypes: [],

  turnTypeReceived: [],

  turnTypePayable: [],

  turnCashTypes: [],

  receiptPaymentSubjectTypes: [],

  receiptPaymentSubjects: [],

  chequeSayadAndBankInfo: {},

  saleDiscountTypes: [],

  saleProcesses: [],

  issueTrackingTypes: [],

  trackingNumbersByChequeNumber: [],

  goals: [],

  subSystems: [],

  companyTypes: [],

  campaigns: [],

  leadSources: [],

  leadStatuses: [],

  leadPropertys: [],

  leadTypes: [],

  workShifts: [],

  leadNotChances: [],

  chanceSaleStatuses: [],

  campaignStatuses: [],

  campaignExecutionPhases: [],

  ageGroups: [],

  chanceTypes: [],

  chanceStatuses: [],

  chanceResults: [],

  saleLines: [],

  saleLineStages: [],

  saleStageTypes: [],

  chancePrioritys: [],

  failedSaleReasons: [],

  strengthWeaknesses: [],

  strengthWeaknessTypes: [],

  furnaces: [],

  furnacePlacements: [],

  orderDateTypes: [],

  projectTypes: [],

  projectExecutionPhases: [],

  leads: [],

  projects: [],

  workDescriptions: [],

  taskStatuses: [],

  taskCategorys: [],

  noteSubjects: [],

  noteCategorys: [],

  noteStatuses: [],

  hamyarRequestTypes: [],

  requestStatuses: [],

  serviceSupports: [],
  serviceSupportSubjects: [],
  serviceSupportStatuses: [],
  serviceSupportCategories: [],
  serviceSupportAnnouncementTypes: [],
  serviceSupportActionTypes: [],

  hamyarContractTypes: [],
  hamyarContractStatuses: [],
  chances: [],

  calls: [],

  messages: [],

  contracts: [],

  meetings: [],

  tasks: [],

  messageStatuses: [],

  messageTypes: [],

  messageActions: [],

  callTypes: [],

  callStatuses: [],

  callNatures: [],

  callCategories: [],

  callSubjects: [],

  leadAddressTypes: [],

  meetingStatuses: [],

  checkListTypes: [],

  taxRateTypes: [],

  addOrMinusTypes: [],

  voucherSearchTypes: [],

  receiveOptions: [],

  paymentOptions: [],

  studyFieldTypes: [],

  degreeTypes: [],

  employmentTypes: [],

  nationalityTypes: [],

  insuranceTypes: [],

  serviceStatuses: [],

  occupationCategories: [],

  taxVehicles: [],

  taxHousings: [],

  decreaseSaleAddMinuses: [],

  giftTypes: [],

  calculateTypes: [],

  departments: [],
  contractTypes: [],
  leaveTypes: [],
  jobGroups: [],
  insuranceWorkplaces: [],
  agreementRows: [],
  calculateDeductionRateTypes: [],
  formulas: [],
  exemptionTypes: [],
  calculateTaxForHourlys: [],
  calculateTaxTypes: [],
  legalTaxExceptions: [],
  functionTypes: [],
  calculateOffOverTimeTypes: [],
  benefitsAndDeductions: [],
  personnels: [],
  additionalContractParameters: [],

  shamsiMonths: [],

  suites: [],

  participation: [],

  crimesRewardSubject: [],

  paymentNotificationType: [],

  estimationSubject: [],

  crimesRewardType: [],

  unitCount: [],

  advanceCartableConfirm: [],

  leaveCartableConfirm: [],
  missionCartableConfirm: [],

  hamsazSmsTemplates: [],

  hamsazSmsSettings: [],

  financialSystemTypes: [],

  excelSamples: [],

  employeeClubPermissions: [],

  saltDateTypes: [],

  saleTeams: [],

  saleRegions: [],

  taxBillTypes: [],

  taxBillPatterns: {},

  taxBillSubjects: [],

  taxBuyerTypes: [],

  taxClearingMethods: [],

  taxInvoiceStatuses: [],

  taxCurrencyTypes: [],

  taxOrganizationTypes: [],

  taxMltTypes: [],

  orderCartableConfirm: [],

  taskDateTypes: [],

  taskDeleteScopes: [],
};
